module.exports = __webpack_public_path__ + "static/media/chris-eagle.65881a92.png";